module.exports = __webpack_public_path__ + "static/media/min-blue.caaa696c.png";